<div class="profile-icon-container">
    <span class="text" [style.color]="textColor">
        {{ initials | uppercase }}
    </span>
</div>
